<template>
  <v-container fluid class="mt-10">
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-card class="pa-4 elevation-3" style="border-radius: 16px">
          <v-card-title class="d-flex align-center" style="border-bottom: 1px solid #e0e0e0">
            <v-icon color="primary" class="mr-2">mdi-account</v-icon>
            <span class="headline font-weight-bold evento-descricao-ajustada">
              <strong class="blue--text">
                {{ servidor && servidor.nome ? servidor.nome : "Nome não disponível" }}
              </strong>
            </span>
          </v-card-title>
          <v-card class="pa-4 mt-4" style="background-color: #fdf5e6; border-radius: 12px">
            <v-row>
              <v-col cols="12" md="8">
                <v-text-field
                  v-if="servidor && servidor.email !== undefined"
                  v-model="servidor.email"
                  label="E-mail"
                  outlined
                  dense
                  color="primary"
                ></v-text-field>
                <span v-else class="red--text">E-mail não disponível</span>
                <v-divider class="my-2"></v-divider>
                <p class="caption mb-0">
                  É indispensável um e-mail que você tenha acesso, pois todo processo de inscrição e login é validado
                  pelo e-mail. Certifique que o e-mail acima está correto ou digite um e-mail válido.
                </p>
              </v-col>
            </v-row>
          </v-card>
          <v-divider class="my-4"></v-divider>
          <v-card v-if="matriculas.length > 0" class="pa-4 mb-2 elevation-1" style="border-radius: 12px">
            <h4 class="font-weight-bold mb-2">Suas Matrículas</h4>
            <v-list dense>
              <v-list-item
                v-for="item in matriculas"
                :key="item.matricula"
                class="mb-2"
                style="background: #f5faff; border-radius: 8px"
              >
                <v-list-item-content>
                  <div class="font-weight-bold">{{ item.matricula }} - {{ item.contrato }}</div>
                  <div>{{ item.cargo }} - {{ item.grupo }}</div>
                  <div>Admissão: {{ item.data_admissao | dateBr("dd/MM/yyyy") }}</div>
                  <div>
                    <strong>
                      <span v-if="item.anos_trabalhados > 0"> {{ item.anos_trabalhados }} Ano(s)</span>
                      <span v-if="item.meses_trabalhados > 0"> {{ item.meses_trabalhados }} Mes(es)</span>
                      <span v-if="item.dias_trabalhados > 0"> {{ item.dias_trabalhados }} Dia(s)</span>
                    </strong>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <hr />
            <v-btn class="mt-5 mb-5" color="success" block :disabled="!podeSalvarInscricao" @click="salvarInscricao">
              Salvar Inscrição
            </v-btn>
          </v-card>
          <v-card v-if="matriculas.length == 0" class="pa-4 mb-2 elevation-1" style="border-radius: 12px">
            <span class="red--text font-weight-bold">Nenhuma matrícula encontrada</span>
          </v-card>
          <v-divider class="my-4"></v-divider>
          <!-- Lista de eventos amigável para mobile -->
          <v-card v-if="eventos.length > 0" class="pa-4 mb-2 elevation-1" style="border-radius: 12px"
            >''
            <h4 class="font-weight-bold mb-4">
              Selecione os eventos que deseja participar e depois clique em salvar. O botão salvar somente sera
              habilitado quando tiver um email informado e no minimo um evento selecionado.
            </h4>
            <p class="mb-4" style="font-size: 1.1rem; color: #1565c0; font-weight: 500">
              <v-icon color="primary" class="mr-1">mdi-checkbox-marked-circle-outline</v-icon>
              Clique no quadrado ao lado do evento para selecionar sua participação.
            </p>
            <v-row>
              <v-col v-for="evento in eventos" :key="evento.pkdatadistribuicao" cols="12" md="6">
                <v-card outlined class="mb-3 evento-card-ajuste" style="border-radius: 10px">
                  <v-card-title
                    class="d-flex align-center"
                    :class="{
                      'evento-card-header-selecionado': eventosSelecionados.includes(evento.pkdatadistribuicao),
                    }"
                    style="background: #fdf5e6"
                  >
                    <div class="evento-checkbox-destaque mr-3">
                      <v-checkbox
                        v-model="eventosSelecionados"
                        :value="evento.pkdatadistribuicao"
                        hide-details
                        dense
                        color="primary"
                        :ripple="true"
                        :input-value="eventosSelecionados.includes(evento.pkdatadistribuicao)"
                        style="transform: scale(1.5)"
                        aria-label="Selecionar evento"
                      ></v-checkbox>
                    </div>
                    <p class="evento-descricao-ajustada">
                      {{ evento.descricao }}
                    </p>
                  </v-card-title>
                  <v-card-text>
                    <div><strong>ID:</strong> {{ evento.pkdatadistribuicao }}</div>
                    <div><strong>Data:</strong> {{ evento.data_distribuicao }}</div>
                    <div><strong>Hora:</strong> {{ evento.h_inicio }}</div>
                    <div><strong>Vagas:</strong> {{ evento.vaga }}</div>
                    <div><strong>Local:</strong> {{ evento.local }}</div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
          <v-card v-if="eventos.length == 0" class="pa-4 mb-2 elevation-1" style="border-radius: 12px">
            <span class="red--text font-weight-bold">Nenhum evento disponível</span>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//import { Libs } from "@/libs/libs";
import filtros from "@/libs/filters";
import { mapGetters } from "vuex";
import RemocaoServices from "../../../services/rh/RemocaoServices";
export default {
  name: "preInscricaoView",
  data: () => ({
    matriculas: [],
    eventos: [],
    eventosSelecionados: [],
  }),
  components: {},
  filters: filtros,
  computed: {
    ...mapGetters({ processoEmAndamento: "remocao/processoSelecionado", servidor: "remocao/getServidorSolicitante" }),
    podeSalvarInscricao() {
      const ano = this.processoEmAndamento?.ano;
      const email = this.servidor?.email;
      return !!ano && !!email && this.eventosSelecionados.length > 0 && this.validarEmail(email);
    },
  },
  methods: {
    async loadMatriculas() {
      if (!this.servidor || !this.servidor.cpf) return;
      const data = await RemocaoServices.localizarMatriculas(this.servidor.cpf);
      this.matriculas = data.filter((item) => {
        return item.data_exoneracao == null;
      });
    },
    async loadDatasEvento() {
      if (!this.servidor || !this.servidor.cpf) return;
      const data = await RemocaoServices.obterDatasDistribuicao(this.processoEmAndamento.ano);
      this.eventos = data;
      this.$nextTick(() => {
        this.ajustarAlturaCards();
      });
    },
    ajustarAlturaCards() {
      // Seleciona todos os cards de eventos
      const cards = document.querySelectorAll(".evento-card-ajuste");
      let maxHeight = 0;
      // Descobre a maior altura
      cards.forEach((card) => {
        card.style.height = "auto";
        if (card.offsetHeight > maxHeight) maxHeight = card.offsetHeight;
      });
      // Aplica a maior altura a todos
      cards.forEach((card) => {
        card.style.height = maxHeight + "px";
      });
    },
    validarEmail(email) {
      // Validação simples de e-mail
      return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
    },
    async salvarInscricao() {
      const ano = this.processoEmAndamento?.ano;
      const cpf = this.servidor?.cpf;
      const datas = this.eventosSelecionados;
      if (!ano || !cpf || datas.length === 0) return;
      const payload = {
        ano,
        cpf,
        datas,
      };
      try {
        // Chame a API para salvar inscrição
        await RemocaoServices.salvarInscricao(payload);
        this.$emit("inscricao-salva", payload);
        this.$root.$emit("showSnackbar", "Inscrição salva com sucesso!");
      } catch (e) {
        this.$root.$emit("showSnackbar", "Erro ao salvar inscrição!");
      }
    },
  },
  mounted: async function () {
    if (!this.servidor || Object.keys(this.servidor).length === 0) {
      // this.$router.push({ name: "initPage" });
    } else {
      await this.loadMatriculas();
      await this.loadDatasEvento();
    }
    window.addEventListener("resize", this.ajustarAlturaCards);
  },
  updated() {
    this.$nextTick(() => {
      this.ajustarAlturaCards();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.ajustarAlturaCards);
  },
};
</script>

<style scoped>
.headline {
  font-size: 1.3rem;
}
.v-card-title {
  font-size: 1.1rem;
}
.v-card {
  transition: box-shadow 0.2s;
}
.v-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}
.v-list-item {
  border: 1px solid #e0e0e0;
}
.evento-checkbox-destaque {
  background: #e3f2fd;
  border: 2px solid #1976d2;
  border-radius: 8px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  transition: box-shadow 0.2s;
}
.evento-checkbox-destaque:focus-within,
.evento-checkbox-destaque:hover {
  box-shadow: 0 0 0 3px #90caf9;
  border-color: #1565c0;
}
.evento-card-header-selecionado {
  background: linear-gradient(90deg, #1976d2 80%, #90caf9 100%) !important;
  color: #fff !important;
  transition: background 0.2s;
}
.evento-descricao-ajustada {
  font-size: 1.15rem;
  font-weight: bold;
  text-align: justify;
  word-break: break-word;
  margin: 0;
}
</style>
